import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

function CategoryForm() {
  const [name, setName] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [imageUrl, setImageUrl] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();


  useEffect(() => {
    if (id) {
      setIsEdit(true);
      fetch(`https://agaram.ematixsolutions.com/api/categories/${id}`)
        .then(res => res.json())
        .then(data => {
          setName(data.name);
          if (data.image_url) setImageUrl(data.image_url);
        })
        .catch(err => alert('Error fetching category: ' + err.message));
    }
  }, [id]);

  const handleImageChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('name', name);
    if (imageFile) formData.append('image', imageFile);
    if (isEdit) formData.append('_method', 'PUT'); // method spoofing

    try {
      const response = await fetch(`https://agaram.ematixsolutions.com/api/categories${isEdit ? `/${id}` : ''}`, {
        method: 'POST', // Laravel expects POST + _method for PUT
        body: formData,
      });

      if (response.ok) {
        alert(`✅ Category ${isEdit ? 'updated' : 'added'} successfully!`);
        navigate('/dashboard');
      } else {
        const errorData = await response.json();
        alert(errorData.message || 'Something went wrong!');
      }
    } catch (err) {
      alert('Error: ' + err.message);
    }
  };

  return (
    <div style={{
      maxWidth: '480px',
      margin: '80px auto',
      padding: '32px',
      borderRadius: '16px',
      boxShadow: '0 12px 24px hsla(0, 0.00%, 0.00%, 0.10)',
      backgroundColor: '#f2f2f2',
      fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
    }}>
      <h2 style={{
        textAlign: 'center',
        color: '#006666',
        marginBottom: '24px',
        fontSize: '24px',
      }}>{isEdit ? 'Edit Category' : 'Add Category'}</h2>

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Category Name"
          value={name}
          required
          onChange={(e) => setName(e.target.value)}
          style={{
            width: '100%',
            padding: '12px',
            marginBottom: '16px',
            borderRadius: '8px',
            border: '1px solid #ccc',
            fontSize: '16px',
          }}
        />

        {isEdit && imageUrl && !imageFile && (
          <div style={{ marginBottom: '16px' }}>
            <label>Current Image:</label>
            <br />
            <img
              src={imageUrl}
              alt="Category"
              style={{
                width: '100px',
                height: '100px',
                objectFit: 'cover',
                borderRadius: '6px',
                border: '1px solid #ccc'
              }}
            />
          </div>
        )}

        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          style={{
            width: '100%',
            padding: '10px',
            marginBottom: '20px',
            borderRadius: '8px',
            border: '1px solid #ccc'
          }}
          name="image"
        />

        <button type="submit" style={{
          width: '100%',
          padding: '12px',
          backgroundColor: 'blue',
          color: '#fff',
          fontWeight: 'bold',
          fontSize: '16px',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer'
        }}>
          {isEdit ? 'Update' : 'Add'} Category
        </button>
      </form>
    </div>
  );
}

export default CategoryForm;